var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"min-height",attrs:{"fluid":"","align":"center"}},[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',[_c('span',[_vm._v(_vm._s(_vm.imgWaiting)+" "+_vm._s(_vm.imgWaiting !== 1 ? "tickets": "ticket")+" por revisar")]),_c('span',{staticStyle:{"float":"right"}},[_vm._v("v1.0.0")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }